export default __webpack_public_path__ + "static/media/switzerland-flag-icon.836d124a.svg";